<template>
    <div>
        <relationHeroList :game_id="game_id"></relationHeroList>
    </div>
</template>
<script>

import relationHeroList from '@/components/relation/games/hero/list.vue';

export default {
    components: {
        relationHeroList
    },
    data () {
        let self = (window.x = this);
        return {
            game_id: 1,
        }
    },
    methods: {
        demo () {
        },
        // end 
    },
    mounted () {
        // this.getData()
    },
    watch: {},
    computed: {}
}
</script>
